import { queryClient } from '@/App';
import { api } from '@/services/api';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import { AddForm, FormType } from './AddForm';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AddModal({ isOpen, onClose }: Props) {

  const toast = useToast();

  async function handleSave(data: FormType) {
    try {
      await api.post('/tipo/endereco', data);
      onClose();
      queryClient.invalidateQueries(['tipo/endereco']);
      toast({
        description: 'Criado!',
        title: 'Sucesso',
        status: 'success'
      })
    }catch(error: any) {
      toast({
        description: JSON.stringify(error?.response?.data?.mensagem || "Erro ao realizar operação", null, 2),
        title: 'Erro',
        status: 'error'
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Adicionar Tipo de Endereço
          <ModalCloseButton />
        </ModalHeader>
        <AddForm handleSave={handleSave} handleCancel={onClose} />
      </ModalContent>
    </Modal>
  );
}
